import React from 'react';
import useAdminDashboard from '../../../hooks/useAdminDashboard';
import {
  DataTile,
  QuickActions,
  RecentActivity,
  WeeklySummary,
} from './components';
import './Dashboard.css';

const AdminDashboard = ({ onNavigate, formsCount }) => {
  const {
    stats,
    trends,
    isLoading,
    recentForms,
    isAdmin,
    hasOfficeAccess,
    isDM,
    isAS,
    refreshData,
    getWelcomeMessage,
    getScopeLabel,
    getTimeSinceRefresh,
  } = useAdminDashboard({ formsCount });

  return (
    <div className="admin-dashboard">
      {isLoading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
          <p>Loading dashboard data...</p>
        </div>
      )}

      <div className="dashboard-header">
        <div>
          <h1>Admin Dashboard</h1>
          <p className="dashboard-subtitle">{getWelcomeMessage()}</p>
          {getScopeLabel() && (
            <div
              style={{
                marginTop: '10px',
                display: 'inline-flex',
                padding: '6px 12px',
                borderRadius: '999px',
                background: 'rgba(49, 130, 206, 0.12)',
                color: '#2b6cb0',
                fontSize: '12px',
                fontWeight: 600,
              }}
            >
              {getScopeLabel()}
            </div>
          )}
        </div>
        <div className="header-actions">
          <span className="last-updated">Updated: {getTimeSinceRefresh()}</span>
          <button
            className="btn-refresh"
            onClick={refreshData}
            disabled={isLoading}
          >
            ↻ {isLoading ? 'Refreshing...' : 'Refresh'}
          </button>
        </div>
      </div>

      {/* Metrics Grid - Improved Data Tiles */}
      <div className="metrics-grid">
        <DataTile
          icon="📊"
          value={stats.totalForms}
          label="Total Forms"
          trend={
            trends.formsLast24h > 0
              ? `${trends.formsLast24h} in last 24h`
              : null
          }
          trendDirection={trends.formsLast24h > 0 ? 'up' : 'neutral'}
          variant="primary"
          onClick={() => onNavigate('forms')}
          subtitle={trends.formsLast24h === 0 ? 'No recent submissions' : null}
        />

        {isAdmin && (
          <DataTile
            icon="👥"
            value={stats.totalUsers}
            label="Portal Users"
            subtitle="Active accounts"
            variant="success"
            onClick={() => onNavigate('users')}
          />
        )}

        {(isAdmin || hasOfficeAccess || isDM) && (
          <DataTile
            icon="🏪"
            value={stats.totalStores}
            label="Store Locations"
            subtitle={isDM ? 'In your district' : 'Across all districts'}
            variant="info"
            onClick={() => onNavigate('stores')}
          />
        )}

        {isAdmin && (
          <DataTile
            icon="🔒"
            value={stats.activeSessions}
            label="Active Sessions"
            subtitle="Currently online"
            variant="warning"
            onClick={() => onNavigate('sessions')}
          />
        )}

        {/* Additional insight tile for non-admin users */}
        {!isAdmin && hasOfficeAccess && (
          <DataTile
            icon="📈"
            value={stats.averageFormsPerDay || 0}
            label="Avg Forms/Day"
            subtitle="Last 7 days"
            variant="warning"
          />
        )}
      </div>

      {/* Weekly Summary Card */}
      <WeeklySummary
        trends={trends}
        stats={stats}
        show={isAdmin || hasOfficeAccess}
      />

      {/* Quick Actions */}
      <QuickActions
        isAdmin={isAdmin}
        isOffice={hasOfficeAccess}
        isDM={isDM}
        isAS={isAS}
        onNavigate={onNavigate}
      />

      {/* Recent Activity */}
      <RecentActivity recentForms={recentForms} onNavigate={onNavigate} />
    </div>
  );
};

export default AdminDashboard;
